import React, { Component } from "react";

import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Preloader from "../../../shared/items/static/preloader";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import { withUnits } from "../../../shared/containers/containerUnits";
import { states } from "../../../reducers/queriesStates";
import { withAuth } from "../../../shared/containers/containerAuth";

import styles from "./cmsUnitChangePanel.module.scss";
import CmsSharedUnitTools from "./CmsSharedUnitTools";
import CmsUnitSettingGrops from "./CmsUnitSettings/CmsUnitSettingGrops";
import CmsReprocessUnitPanel from "./CmsReprocessUnitPanel";
import CmsHowenVideosat from "./CmsHowenVideosat/CmsHowenVideosat";

class CmsUnitChangePanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      unitTitle: props.currentUnit.title,
      registerNumber: props.currentUnit.registerNumber,
      inActive: props.currentUnit.inActive,
      number: props.currentUnit.number,
      isFail: false,
      tabIndex: 0,
    };
  }

  componentDidUpdate(prevProps) {
    const { changeUnitDataState, changeUnitSharedDataState } = this.props;

    if (
      (prevProps.changeUnitDataState === states.REQUEST && changeUnitDataState === states.FAILURE) ||
      (prevProps.changeUnitSharedDataState === states.REQUEST && changeUnitSharedDataState === states.FAILURE)
    ) {
      this.setState({ isFail: true });
      setTimeout(() => {
        this.setState({ isFail: false });
      }, 3000);
    }
  }

  handleClick() {
    const { onUpdateUnitSupport, currentUnit, companyId } = this.props;
    const { unitTitle, registerNumber, inActive, number } = this.state;

    onUpdateUnitSupport(currentUnit.id, { title: unitTitle, registerNumber, inActive, number, companyId });
  }

  getTabs() {
    const { tabIndex } = this.state;
    const titles = ["Настройки", "Доступ", "Повторная обработка данных", "Howen videosat интеграция"];

    return titles.map((item, index) => {
      return (
        <div key={index} className={tabIndex === index ? styles.cmsTabActive : styles.cmsTab} onClick={this.selectTab.bind(this, index)}>
          {item}
        </div>
      );
    });
  }

  selectTab(tabIndex) {
    this.setState({ tabIndex });
  }

  viewTab() {
    const { tabIndex } = this.state;
    const { currentUnit, companyId } = this.props;

    switch (tabIndex) {
      case 0:
        return <CmsUnitSettingGrops height={600} />;
      case 1:
        return <CmsSharedUnitTools />;
      case 2:
        return <CmsReprocessUnitPanel unit={currentUnit} />;
      case 3:
        return <CmsHowenVideosat unit={currentUnit} companyId={companyId} />;
      default:
        return null;
    }
  }

  render() {
    const { changeUnitDataState, onClose } = this.props;
    const { unitTitle, registerNumber, inActive, isFail, number } = this.state;

    return (
      <div className={styles.cmsUnitChangePanelContainer}>
        <div className={styles.cmsUnitPanelContent}>
          <div className={styles.ccmsUnitPanelTitleBlock}>
            <h1>
              Панель действий с {this.props.currentUnit.title} {this.props.currentUnit.registerNumber}
            </h1>
            {isFail ? (
              <div className={styles.error}>
                <h2> Ошибка запроса</h2>
              </div>
            ) : null}
            <div className={styles.cmsUnitPanelClose}>
              <TooltipWrapper title={"Закрыть"} position="top">
                <div onClick={onClose}>
                  <HighlightOffIcon />
                </div>
              </TooltipWrapper>
            </div>
          </div>

          <div className={styles.cmsUnitPanelActionContainer}>
            <div className={styles.cmsUnitPanelUpdateContainer}>
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={inActive}
                      onChange={(e) => {
                        this.setState({ inActive: e.target.checked });
                      }}
                    />
                  }
                  label="Не активна"
                />
              </div>

              <div>
                <TextField
                  id="outlined-basic"
                  label="Наименование"
                  variant="outlined"
                  value={unitTitle}
                  onChange={(e) => {
                    this.setState({ unitTitle: e.target.value });
                  }}
                />
              </div>

              <div>
                <TextField
                  id="outlined-basic"
                  label="Гос номер"
                  variant="outlined"
                  value={registerNumber}
                  onChange={(e) => {
                    this.setState({ registerNumber: e.target.value });
                  }}
                />
              </div>

              <div>
                <TextField
                  id="outlined-basic"
                  label="Номер в списке"
                  variant="outlined"
                  value={number}
                  type="number"
                  disabled={inActive}
                  onChange={(e) => {
                    this.setState({ number: e.target.value });
                  }}
                />
              </div>

              <div>
                {changeUnitDataState === states.REQUEST ? (
                  <Preloader />
                ) : (
                  <ButtonPrimary handleClick={this.handleClick.bind(this)} title="Обновить" />
                )}
              </div>
            </div>
          </div>
          <div className={styles.cmsUnitPanelCompaniesContainer}>
            <div className={styles.cmsTabsContainer}>{this.getTabs()}</div>
            {this.viewTab()}
          </div>
        </div>
      </div>
    );
  }
}

export default withUnits(withAuth(CmsUnitChangePanel));
